"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var tmplAttrGetters = {
  industryAttrList: function industryAttrList(state) {
    return state.industryAttrList;
  },
  checkedAttrIdList: function checkedAttrIdList(state) {
    return state.checkedAttrIdLst;
  },
  settingAttrId: function settingAttrId(state) {
    return state.settingAttrId;
  },
  settingAttrScope: function settingAttrScope(state) {
    return state.checkedAttrConfig.scope;
  },
  settingAttrChannelCodes: function settingAttrChannelCodes(state) {
    return state.checkedAttrConfig.channelCodeList;
  },
  settingAttrNameAlias: function settingAttrNameAlias(state) {
    return state.checkedAttrConfig.attrNameAlias;
  },
  settingAttrRequire: function settingAttrRequire(state) {
    return state.checkedAttrConfig.require;
  },
  settingAttrSelect: function settingAttrSelect(state) {
    return state.checkedAttrConfig.select;
  },
  settingAttrType: function settingAttrType(state) {
    return state.checkedAttrConfig.type;
  },
  settingAttrCascade: function settingAttrCascade(state) {
    return state.checkedAttrConfig.cascade;
  },
  settingAttrCheckedValIds: function settingAttrCheckedValIds(state) {
    return state.checkedAttrConfig.checkedAttrValIds;
  },
  settingAttrCheckedValues: function settingAttrCheckedValues(state) {
    return state.checkedAttrConfig.checkedValues;
  },
  settingAttrValues: function settingAttrValues(state) {
    return state.checkedAttrConfig.values;
  }
};
var _default = exports.default = tmplAttrGetters;